<template>
    <div class="list-table">
        <table>
            <tr>
                <th
                    v-for="(column, headerIndex) in listHeader"
                    :key="`h-${headerIndex}`"
                >
                    <div v-if="column == 'select'">
                        <CheckBox color="apple" v-model="selectedAll" />
                    </div>
                    <div v-else-if="column != 'key'">
                        {{ column }}
                    </div>
                </th>
            </tr>
            <tr v-for="(row, rowIndex) in content" :key="`r-${rowIndex}`">
                <td
                    v-for="(column, columnIndex) in listHeader"
                    :key="`c-${columnIndex}`"
                >
                    <div v-if="column == 'select'">
                        <CheckBox color="apple" v-model="row[column]" />
                    </div>
                    <div v-else-if="column != 'key'">
                        {{ row[column] }}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            selectedAll: false
        }
    },
    props: {
        content: Array
    },
    computed: {
        listHeader() {
            return this.content && this.content.length > 1
                ? Object.keys(this.content[0]).filter(k => k != 'key')
                : []
        }
    }
}
</script>
<style lang="scss" scoped>
.list-table {
    max-height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}
::-webkit-scrollbar {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    width: 2px;
    height: 2px;
}
table {
    text-align: left;
    border-collapse: collapse;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    border: none;
}
tr,
td,
th {
    border-bottom: $list-border;
    padding: 0.6rem 0.5rem;
    font-size: 1.2rem;
}
</style>
